import styled from 'styled-components';
import { globalTheme } from '@cld/component-theme';

export const FolderBox = styled.div`
  padding-left: ${globalTheme.spacing.md};
  padding-bottom: ${globalTheme.spacing.sm};
`;
export const SearchBox = styled.div`
  padding-left: ${globalTheme.spacing.md};
`;

export const SearchFilterByAssetTypeBox = styled.div`
  padding-left: ${globalTheme.spacing.md};
  margin-left: ${globalTheme.spacing.xxs};
  padding-bottom: ${globalTheme.spacing.sm};
  width: calc(${globalTheme.spacing.lg} * 11);
`;
export const SearchFilterByCustomExpressionBox = styled.div`
  padding-left: ${globalTheme.spacing.md};
  margin-left: ${globalTheme.spacing.xxs};
  padding-bottom: ${globalTheme.spacing.sm};
`;
